export default __webpack_public_path__ + "static/media/assignedActive.84541ff7.svg";